/**
 * @Author: zpc
 * @Description:  数据自动对接枚举
 * @DateTime: Created in 2021-08-12 14:27
 */

 import EnumItem, { enumMixn } from './enumItem';

 /**
  * 数据自动对接处理
  */
 // 数据上传状态
 let EnumIsOpenStatus = { 
     开启: new EnumItem('开启', 1),
     关闭: new EnumItem('关闭', 2),
     ...enumMixn,
 };
 export default EnumIsOpenStatus;
 
 //是否验证token
 export const EnumIsTokenStatus = {
     验证: new EnumItem('验证', 1),
     不验证: new EnumItem('不验证', 2),
     ...enumMixn,
 };
 
 //鉴权是否url传参
 export const EnumIsUrlParameterStatus = {
     是: new EnumItem('是', 1),
     否: new EnumItem('否', 2),
     ...enumMixn,
 };


 //是否header上传token
 export const EnumIsHeaderTokenStatus = {
     是: new EnumItem('是', 1),
     否: new EnumItem('否', 2),
     ...enumMixn,
 };
 